module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/fornitori/fornitori.component.scss
// module id = ./src/app/fornitori/fornitori.component.scss
// module chunks = main